import { cn } from '@/shared/utils';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components';
import { useModalStore } from '@/shared/lib';

interface Props {
  onSubmit: () => void;
  onHistoryClick: () => void;
  invoicesCount?: number;
  isHistoryLoading: boolean;
}

export function BankTransferModalFooter({
  onSubmit,
  onHistoryClick,
  invoicesCount,
  isHistoryLoading,
}: Props) {
  const { t } = useTranslation();

  const { getAllState } = useModalStore();

  const { isLoading } = getAllState() as {
    isLoading?: boolean;
    screen?: string;
  };

  return (
    <div className="w-full flex flex-col gap-[1.6rem]">
      <Button
        type="submit"
        variant="default"
        size="lg"
        disabled={isLoading}
        loading={isLoading}
        onClick={onSubmit}
        className={cn('w-full')}>
        {t('depositMethods.bankTransfer.createInvoice')}
      </Button>
      <Button
        loading={isHistoryLoading}
        disabled={isHistoryLoading}
        variant="secondary"
        size="lg"
        onClick={onHistoryClick}
        className={cn('w-full')}>
        <span
          className={'flex flex-row items-center justify-center gap-[0.4rem]'}>
          {t('depositMethods.bankTransfer.invoices')}
          {invoicesCount && (
            <div
              className={
                'min-w-[2.0rem] px-[0.4rem] h-[2.0rem] flex items-center justify-center bg-red rounded-full'
              }>
              <span
                className={
                  'headline5 text-white leading-none flex items-center justify-center translate-x-[-0.5px]'
                }>
                {invoicesCount}
              </span>
            </div>
          )}
        </span>
      </Button>
    </div>
  );
}
